import { PYTHON_SERVICE_ENDPOINTS, PythonAPI } from '@buildwise/libs/services';

class PythonProceduresAPI extends PythonAPI {
  public saveFilesMetaData(payload: {
    filesList: {
      documentName: string;
      documentType: string;
      documentDirectory: string;
      projectId?: string;
      documentSize: number;
    }[];
    companyId: string;
    level: 'company' | 'project';
  }) {
    return this.post<{
      filesList: {
        UploadUrl: string;
        companyId: string;
        createdAt: string | Date;
        createdBy: string;
        documentDirectory: string;
        documentName: string;
        documentSize: number;
        documentType: string;
        id: string;
        isDocumentUploaded: boolean;
        s3Key: string;
      }[];
    }>(PYTHON_SERVICE_ENDPOINTS.SAVE_FILES_META_DATA, payload);
  }

  public uploadFileToS3({
    s3Url,
    file,
    uploadProgress,
  }: {
    s3Url: string;
    file: File;
    uploadProgress: (uploadedPercentage: number) => void;
  }) {
    return this.put(s3Url, file, {
      headers: { 'Content-Type': file.type },
      onUploadProgress: (e) => {
        var percentCompleted = Math.round((e.loaded * 100) / e.total);
        uploadProgress(percentCompleted);
      },
    });
  }

  public verifyUploadedFiles(payload: {
    id: string;
    fileMD5Hash: string;
    MimeType: string;
    companyId: string;
  }) {
    return this.put(PYTHON_SERVICE_ENDPOINTS.VERIFY_UPLOADED_FILES, payload);
  }
}

const pythonProceduresAPI = new PythonProceduresAPI();
export default pythonProceduresAPI;
